<div fxLayout="column">
  <mat-label>
    <h1>Review Details</h1>
  </mat-label>
</div>
<div class="review-created-invitation">
  <h5>Review the information below to make sure everything is correct.</h5>
  <app-personal-details [reviewState]="reviewState"></app-personal-details>
  <p>Keep in mind – once this person accepts your invite, you won’t be able to remove them without closing the
      shared account. For more information on joint accounts, please visit our FAQs.</p>
</div>
